import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class StatusLabel extends Component {
  render() {
    const statusClasses = status => {
      switch (status) {
        case 1:
          return 'label-success';
        case 2:
          return 'label-warning';
        case 3:
          return 'label-primary';
        case 4:
          return 'label-info';
        case 5:
          return 'label-danger';
        case 6:
          return 'label-primary';
        case 7:
          return 'label-warning';
        default:
          return '';
      }
    };
    return (
      <span
        className={`label label-light max-full-width ${statusClasses(
          this.props.status
        )}`}
      >
        <div className="text-overflow">
          {this.props.taskStatuses[this.props.status]}
        </div>
      </span>
    );
  }
}

StatusLabel.defaultProps = {
  selectTitleNullValue: 'Не выбрано',
  placeholder: null,
  value: null
};

StatusLabel.propTypes = {
  status: PropTypes.number.isRequired,
  taskStatuses: PropTypes.arrayOf(PropTypes.string).isRequired
};

const mapStateToProps = state => ({
  taskStatuses: getItemFromRefList(state, 'taskStatuses')
});

export default withRouter(connect(mapStateToProps)(StatusLabel));



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/StatusLabel/StatusLabel.js